export default __webpack_public_path__ + "static/media/gitlab.44600fbd.png";